import apiClient from './apiClient';

export interface QueryParams {
  vendorFrom?: string;
  vendorTo?: string;
}

export interface VendorQualRow {
  doc_no: string;
  vendor_type: string;
  dept_approval: string;
  rd_approval: string;
  gm_approval: string;
  approved: boolean;
  gm_note: string;
}

export interface ApproveItem {
  doc_no: string;
  gm_note: string;
}

export interface ApproveRequest {
  items: ApproveItem[];
}

export interface QueryResponse {
  data: VendorQualRow[];
  count: number;
  message?: string;
}

export interface ApproveResponse {
  approved_count: number;
  message: string;
}

export const pw150kApi = {
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/pw150k/query', params);
    return res.data;
  },
  async approve(req: ApproveRequest): Promise<ApproveResponse> {
    const res = await apiClient.post('/api/pw150k/approve', req);
    return res.data;
  },
  async lookupName(type: string, code: string): Promise<string> {
    if (!code?.trim()) return '';
    try {
      const res = await apiClient.get(`/api/pw150k/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch { return ''; }
  },
};
